/**
 * Parallax background
 *
 */
const parallax = document.querySelectorAll('.bg-parallax')
for (const item of parallax) {
    item.style.backgroundImage = `url(${item.dataset.imageParallax})`
}
